var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(" " + _vm._s(_vm.$ct("F3.title")) + " ")]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  _c("w-checkbox", {
                    attrs: { fancy: "", label: _vm.$ct("labels.clear-f3") },
                    model: {
                      value: _vm.generalSettings.ClearF3SearchFilter,
                      callback: function ($$v) {
                        _vm.$set(
                          _vm.generalSettings,
                          "ClearF3SearchFilter",
                          $$v
                        )
                      },
                      expression: "generalSettings.ClearF3SearchFilter",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  !_vm.$wf.isSmDown
                    ? _c("w-select", {
                        style: { flexShrink: 0 },
                        attrs: {
                          label: _vm.$ct("labels.select-f3-products"),
                          items: _vm.items1,
                          value: _vm.generalSettings.DefaultProductsF3Browse,
                          fancy: "",
                          up: "",
                        },
                        on: { input: _vm.onInputBrowse1 },
                        model: {
                          value: _vm.generalSettings.DefaultProductsF3Browse,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.generalSettings,
                              "DefaultProductsF3Browse",
                              $$v
                            )
                          },
                          expression: "generalSettings.DefaultProductsF3Browse",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  !_vm.$wf.isSmDown
                    ? _c("w-select", {
                        style: { flexShrink: 0 },
                        attrs: {
                          label: _vm.$ct("labels.select-f3-sales"),
                          items: _vm.items2,
                          value: _vm.generalSettings.DefaultSalesF3Browse,
                          fancy: "",
                          up: "",
                        },
                        on: { input: _vm.onInputBrowse1 },
                        model: {
                          value: _vm.generalSettings.DefaultSalesF3Browse,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.generalSettings,
                              "DefaultSalesF3Browse",
                              $$v
                            )
                          },
                          expression: "generalSettings.DefaultSalesF3Browse",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  !_vm.$wf.isSmDown
                    ? _c("w-select", {
                        style: { flexShrink: 0 },
                        attrs: {
                          label: _vm.$ct("labels.select-f3-sale-rows"),
                          items: _vm.items4,
                          value: _vm.generalSettings.DefaultSaleRowsF3Browse,
                          fancy: "",
                          up: "",
                        },
                        on: { input: _vm.onInputBrowse1 },
                        model: {
                          value: _vm.generalSettings.DefaultSaleRowsF3Browse,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.generalSettings,
                              "DefaultSaleRowsF3Browse",
                              $$v
                            )
                          },
                          expression: "generalSettings.DefaultSaleRowsF3Browse",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  !_vm.$wf.isSmDown
                    ? _c("w-select", {
                        style: { flexShrink: 0 },
                        attrs: {
                          label: _vm.$ct("labels.select-f3-bank-sales"),
                          items: _vm.items2,
                          value: _vm.generalSettings.DefaultBankSalesF3Browse,
                          fancy: "",
                          up: "",
                        },
                        on: { input: _vm.onInputBrowse1 },
                        model: {
                          value: _vm.generalSettings.DefaultBankSalesF3Browse,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.generalSettings,
                              "DefaultBankSalesF3Browse",
                              $$v
                            )
                          },
                          expression:
                            "generalSettings.DefaultBankSalesF3Browse",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  !_vm.$wf.isSmDown
                    ? _c("w-select", {
                        style: { flexShrink: 0 },
                        attrs: {
                          label: _vm.$ct("labels.select-f3-bank-purchases"),
                          items: _vm.items3,
                          value: _vm.generalSettings.DefaultPurchaseF3Browse,
                          fancy: "",
                          up: "",
                        },
                        on: { input: _vm.onInputBrowse1 },
                        model: {
                          value: _vm.generalSettings.DefaultPurchaseF3Browse,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.generalSettings,
                              "DefaultPurchaseF3Browse",
                              $$v
                            )
                          },
                          expression: "generalSettings.DefaultPurchaseF3Browse",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { sm: "12" } },
                [
                  !_vm.$wf.isSmDown
                    ? _c("w-select", {
                        style: { flexShrink: 0 },
                        attrs: {
                          label: _vm.$ct("labels.select-f3-document-purchases"),
                          items: _vm.items17,
                          value:
                            _vm.generalSettings
                              .DefaultPurchaseDocumentRowF3Browse,
                          fancy: "",
                          up: "",
                        },
                        on: { input: _vm.onInputBrowse1 },
                        model: {
                          value:
                            _vm.generalSettings
                              .DefaultPurchaseDocumentRowF3Browse,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.generalSettings,
                              "DefaultPurchaseDocumentRowF3Browse",
                              $$v
                            )
                          },
                          expression:
                            "generalSettings.DefaultPurchaseDocumentRowF3Browse",
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-card-actions",
        [
          _c("w-spacer"),
          _c("w-button", { on: { click: _vm.save } }, [
            _vm._v(_vm._s(_vm.$ct("common.save"))),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }